import { render, staticRenderFns } from "./borrowMoneyClickList.vue?vue&type=template&id=37cd9440&"
import script from "./borrowMoneyClickList.vue?vue&type=script&lang=js&"
export * from "./borrowMoneyClickList.vue?vue&type=script&lang=js&"
import style0 from "./borrowMoneyClickList.vue?vue&type=style&index=0&id=37cd9440&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37cd9440')) {
      api.createRecord('37cd9440', component.options)
    } else {
      api.reload('37cd9440', component.options)
    }
    module.hot.accept("./borrowMoneyClickList.vue?vue&type=template&id=37cd9440&", function () {
      api.rerender('37cd9440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/borrowMoney/borrowMoneyClickList.vue"
export default component.exports